/**
 * Spec 275 (R3): cuando la persona misma cambia algo (aprobar, descartar, volver,
 * «Volver a este precio», «Revisar ahora», recalcular), la franja «Hay cambios
 * nuevos» no tiene que aparecer. I13 de la auditoría: mientras una acción propia
 * está en curso no se sondea (si no, se ve la corrida propia en curso, o el
 * recálculo propio que escribe después del 202), y al terminar se vuelve a
 * tomar la firma.
 */
export const EVENTO_CAMBIO_PROPIO = 'prixia:cambio-propio';
let enCurso = 0;
export const hayCambioPropioEnCurso = () => enCurso > 0;

/** Empieza una acción propia; devuelve con qué terminarla (una sola vez). */
export function empezarCambioPropio(): () => void {
  enCurso++;
  let hecho = false;
  return () => {
    if (hecho) return;
    hecho = true;
    enCurso--;
    window.dispatchEvent(new Event(EVENTO_CAMBIO_PROPIO));
  };
}

/** Envuelve un pedido que cambia algo: `conCambioPropio(apiClient.post(...))`. */
export async function conCambioPropio<T>(pedido: Promise<T>): Promise<T> {
  const terminar = empezarCambioPropio();
  try {
    return await pedido;
  } finally {
    terminar();
  }
}
